<!--响应式文章大纲-->
<template>
  <div class="current-menu-bar" v-show="visible">
    <div class="class-menu-bar-modal" @click="handleClose"></div>

    <div class="current-menu-bar-body" id="menu-bar-id">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "current-menu-bar",
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    mounted() {
    },
    methods: {
      handleClose() {
        this.$emit('close');
      }
    }
  }
</script>

<style lang="stylus">
  .class-menu-bar-modal {
    width: 100%;
    height: 100%;
    background: #333;
    opacity: 0.7;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1088888888;
  }

  .current-menu-bar-body {
    width: 85%;
    right: 0;
    position: fixed;
    bottom: 0;
    background: #FFF;
    height: 100%;
    z-index: 1088888889;
    padding: 10px;
    font-size: 14px;
    overflow: scroll;

    .markdown-body ul {
      padding: 0 !important;
    }

    .markdown-toc-list li {
      padding: 5px 0 0 10px;
      list-style-position: inside;
    }
  }
</style>
